import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useParams, Link, useNavigate } from "react-router-dom";
import { authFetch } from '../auth';


const formatDateTime = (isoString) => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  return date.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
// Форматируем время из секунд в "X мин Y сек"
const formatTime = (seconds) => {
  if (seconds === null || seconds === undefined) return "-";
  if (seconds < 60) return `${seconds} сек`;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return secs === 0 ? `${mins} мин` : `${mins} мин ${secs} сек`;
};

// Выводим поля, если данных нет — "-"
const displayField = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

const PublicFly = () => {
  const { id } = useParams();
  const [fly, setFly] = useState({});

  const [displayData, setDisplayData] = useState([]);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    // if (!localStorage.getItem("token")) return;

    authFetch("/api/flydata/public/" + id)
      .then((response) => response.json())
      .then((data) => {
        setFly(data);
      });
  }, [id]);

  const modalOverlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  };

  const menuItemStyle = {
    padding: "10px",
    cursor: "pointer",
    color: "#F3F4F6",
    borderRadius: "8px",
    transition: "background 0.2s",
    textAlign: "left",
  };
  const modalTitleStyle = {
    fontSize: "22px",
    marginBottom: "20px",
  };
  const inputStyle = {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid rgba(255,255,255,0.2)",
    backgroundColor: "rgba(31, 41, 55, 0.9)",
    color: "#F3F4F6",
    outline: "none",
  };
  const cancelBtnStyle = {
    flex: 1,
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.2)",
    backgroundColor: "transparent",
    color: "#F3F4F6",
    cursor: "pointer",
  };
  const modalStyle = {
    backgroundColor: "rgba(17, 24, 39, 0.95)",
    borderRadius: "16px",
    padding: "30px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
    color: "#F3F4F6",
  };



  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          width: "95%",
          maxWidth: "1200px",
          backgroundColor: "rgba(42, 18, 99, 0.69)",
          borderRadius: "20px",
          border: "1px solid rgba(255,255,255,0.2)",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          padding: "30px",
          position: "relative",
        }}
      >

        <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#fff" }}>
          Подробности о полете
        </h2>


        {/* Информация о прыжке - логические блоки */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: "20px",
            gap: "15px",
          }}
        >
          {/* Локация */}
          <div style={{ flex: "1 1 250px", background: "rgba(17,17,17,0.6)", padding: "15px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", color: "#fff" }}>
            <p><strong>Аэротруба:</strong> {displayField(fly.windtunnel)}</p>
            <p><strong>Страна:</strong> {displayField(fly.country)}</p>
            <p><strong>Город:</strong> {displayField(fly.city)}</p>
          </div>

          {/* Прыжок и аппарат */}
          <div style={{ flex: "1 1 250px", background: "rgba(17,17,17,0.6)", padding: "15px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", color: "#fff" }}>
            <p><strong>Номер полета:</strong> {displayField(fly.flyNumber)}</p>
            <p><strong>Дата и время:</strong> {formatDateTime(fly.dateTime)}</p>
          </div>

          {/* Высоты и скорости */}
          <div style={{ flex: "1 1 250px", background: "rgba(17,17,17,0.6)", padding: "15px", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.2)", color: "#fff" }}>
            <p><strong>Продолжительность полета:</strong> {displayField(fly.duration)} мин</p>
            <p><strong>После полета остался депозит:</strong> {displayField(fly.hasTime)} мин</p>
          </div>
        </div>

        {/* Комментарий */}
        <div style={{
          margin: "20px auto",
          background: "rgba(17,17,17,0.7)",
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid rgba(255,255,255,0.2)",
          width: "100%",
          maxWidth: "900px",
          color: "#fff",
          textAlign: "center",
          overflowWrap: "break-word",
          boxSizing: "border-box",
        }}>
          <h3 style={{ color: "#FFD700", marginBottom: "10px" }}>Описание полета</h3>
          <p style={{ whiteSpace: "pre-wrap", textAlign: "center", margin: 0 }}>
            {displayField(fly.comment)}
          </p>
        </div>

        {/* Кнопки навигации */}


        {/* Кнопки навигации */}
        <div
          style={{
            marginTop: "20px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <button style={portalBtnStyle} onClick={() => navigate("/")}>
            Перейти на портал
          </button>
        </div>
      </div>

    </div>
  );
};

export default PublicFly;
const portalBtnStyle = {
  padding: "14px 28px",
  borderRadius: "12px",
  border: "none",
  background: "linear-gradient(135deg, #10B981, #059669)",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  cursor: "pointer",
};